import CalendarLayout from "@/modules/calendar/components/layout"

export default function CalendarPage() {
  return <CalendarLayout />
}
